import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getStoreRegionInfo } from 'services/api/store';
import { ApiQueryKey } from 'services/config/queryKey';
import { PlatformRegions } from '../types';

export interface UseStoreRegionOptionsResult {
  platforms: General.PlatformUpperCase[];
  regions: General.UpperCaseRegion[];
  platformRegionMap: PlatformRegions;
  loading: boolean;
}

export default function useStoreRegionOptions(): UseStoreRegionOptionsResult {
  const { data, isLoading } = useQuery({
    queryKey: [ApiQueryKey.StoreRegionInfo, 'SensitiveWord'],
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      const ret = await getStoreRegionInfo({
        scene: 'SENSITIVE_WORDS',
      });
      return ret.data.data;
    },
  });

  return useMemo(() => {
    if (!data) {
      return { platforms: [], regions: [], platformRegionMap: {}, loading: isLoading };
    }

    const platformRegionMap = data.reduce<PlatformRegions>((res, cur) => {
      res[cur.platform] = [...(res[cur.platform] || []), cur.region];
      return res;
    }, {});

    const platforms = Object.keys(platformRegionMap).sort() as General.PlatformUpperCase[];
    const regions = Array.from(
      new Set(Object.values(platformRegionMap).flat()),
    ).sort() as General.UpperCaseRegion[];

    return { platforms, regions, platformRegionMap, loading: isLoading };
  }, [data, isLoading]);
}
